/* ─────────────────────────────────────────────────────────────
   FREE GIFT ENGINE — cart logic
   File: assets/free-gift-engine.js
   Loaded once from theme.liquid with `defer`.
   ───────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  if (window.__BV_FREE_GIFT_ENGINE__) return;

  var GIFT_PROP = '_bv_free_gift';
  var CAMPAIGN_PROP = '_bv_campaign';
  var SRC_PROP = '_bv_gift_source';
  var CART_PATHS = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];
  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  var originalFetch = window.fetch.bind(window);

  var state = {
    cart: null,
    queue: Promise.resolve(),
    lastPct: null,
    confettiFired: false
  };

  function root() { return document.getElementById('bv-free-gift'); }
  function el(sel) { var r = root(); return r ? r.querySelector(sel) : null; }

  function readCampaign() {
    var r = root();
    if (!r) return null;
    var campaign = {
      id: r.dataset.campaignId,
      threshold: parseInt(r.dataset.threshold, 10),
      variantId: parseInt(r.dataset.giftVariant, 10),
      productId: parseInt(r.dataset.giftProduct, 10),
      giftName: r.dataset.giftName || 'Free Gift',
      unlockMessage: r.dataset.unlockMessage || '',
      confetti: r.dataset.confetti !== 'false',
      moneyFormat: r.dataset.moneyFormat || '${{amount}}'
    };
    if (!campaign.id || !campaign.threshold || !campaign.variantId) return null;
    return campaign;
  }

  function routeFor(name, fallback) {
    return (window.routes && window.routes[name]) || fallback;
  }

  function formatMoney(cents, campaign) {
    var fmt = (campaign && campaign.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/g, value);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function fetchCart() {
    return originalFetch(routeFor('cart_url', '/cart') + '.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { state.cart = cart; return cart; });
  }

  function cartMutate(path, payload, withSections) {
    if (withSections) {
      payload.sections = SECTIONS;
      payload.sections_url = window.location.pathname;
    }
    return originalFetch(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) {
        return res.json().catch(function () { return {}; }).then(function (body) {
          throw new Error(body.description || body.message || 'Cart request failed');
        });
      }
      return res.json();
    });
  }

  function isGiftLine(item) {
    return !!(item.properties && item.properties[GIFT_PROP] === 'true');
  }

  function isStaleGift(item, campaign) {
    return isGiftLine(item) &&
      (!item.properties[CAMPAIGN_PROP] || item.properties[CAMPAIGN_PROP] !== campaign.id);
  }

  function giftLines(cart) { return cart.items.filter(isGiftLine); }

  function paidGiftProductLines(cart, campaign) {
    return cart.items.filter(function (item) {
      return item.product_id === campaign.productId && !isGiftLine(item);
    });
  }

  function qualifyingSubtotal(cart, campaign) {
    return cart.items.reduce(function (sum, item) {
      if (item.product_id === campaign.productId || isGiftLine(item)) return sum;
      return sum + item.final_line_price;
    }, 0);
  }

  function isUnlocked(cart, campaign) {
    return qualifyingSubtotal(cart, campaign) >= campaign.threshold;
  }

  function sectionInnerHTML(html, selector) {
    var node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return node ? node.innerHTML : null;
  }

  function swapDrawerSections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      var inner = document.querySelector('cart-drawer .drawer__inner');
      var fresh = sectionInnerHTML(sections['cart-drawer'], '.drawer__inner');
      if (inner && fresh !== null) inner.innerHTML = fresh;
    }
    if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var freshBubble = sectionInnerHTML(sections['cart-icon-bubble'], '.shopify-section');
      if (bubble && freshBubble !== null) bubble.innerHTML = freshBubble;
    }
  }

  function syncEmptyState(cart) {
    var isEmpty = cart.item_count === 0;
    var drawer = document.querySelector('cart-drawer');
    var drawerItems = document.querySelector('cart-drawer-items');
    if (drawer) drawer.classList.toggle('is-empty', isEmpty);
    if (drawerItems) drawerItems.classList.toggle('is-empty', isEmpty);
  }

  function enqueue(taskFn) {
    state.queue = state.queue.then(taskFn).catch(function (err) {
      console.warn('[Free Gift Engine]', err);
    });
    return state.queue;
  }

  function addGiftLine(campaign, variantId, source, withSections) {
    var props = {};
    props[GIFT_PROP] = 'true';
    props[CAMPAIGN_PROP] = campaign.id;
    props[SRC_PROP] = source;
    return cartMutate(
      routeFor('cart_add_url', '/cart/add') + '.js',
      { id: variantId, quantity: 1, properties: props },
      withSections
    );
  }

  function changeLine(key, quantity, withSections) {
    return cartMutate(
      routeFor('cart_change_url', '/cart/change') + '.js',
      { id: key, quantity: quantity },
      withSections
    );
  }

  function addPlainLine(variantId, quantity, withSections) {
    return cartMutate(
      routeFor('cart_add_url', '/cart/add') + '.js',
      { id: variantId, quantity: quantity },
      withSections
    );
  }

  function claim() {
    return enqueue(function () {
      return fetchCart().then(function (cart) {
        var campaign = readCampaign();
        if (!campaign) return;
        if (!isUnlocked(cart, campaign) || giftLines(cart).length > 0) {
          return render(cart);
        }
        var existing = paidGiftProductLines(cart, campaign)[0];
        var op = existing
          ? changeLine(existing.key, existing.quantity - 1, false).then(function () {
              return addGiftLine(campaign, existing.variant_id, 'converted', true);
            })
          : addGiftLine(campaign, campaign.variantId, 'added', true);

        return op.then(function (resp) {
          swapDrawerSections(resp.sections);
          return fetchCart().then(function (fresh) {
            syncEmptyState(fresh);
            render(fresh);
            restoreFocus();
          });
        });
      });
    });
  }

  function reconcile(cart) {
    var campaign = readCampaign();
    if (!campaign) return Promise.resolve(cart);

    var gifts = giftLines(cart);
    if (gifts.length === 0) return Promise.resolve(cart);

    var unlocked = isUnlocked(cart, campaign);
    var ops = [];
    var keptOne = false;

    gifts.forEach(function (gift) {
      var source = gift.properties && gift.properties[SRC_PROP];
      var stale = isStaleGift(gift, campaign);
      var shouldKeep = unlocked && !stale && !keptOne;

      if (shouldKeep) {
        keptOne = true;
        if (gift.quantity > 1) {
          ops.push(function () { return changeLine(gift.key, 1, true); });
        }
        return;
      }

      if (source === 'converted') {
        ops.push(function () {
          return changeLine(gift.key, 0, false).then(function () {
            return addPlainLine(gift.variant_id, gift.quantity, true);
          });
        });
      } else {
        ops.push(function () { return changeLine(gift.key, 0, true); });
      }
    });

    if (ops.length === 0) return Promise.resolve(cart);

    return ops
      .reduce(function (chain, op) { return chain.then(op); }, Promise.resolve())
      .then(function (lastResp) {
        swapDrawerSections(lastResp && lastResp.sections);
        return fetchCart().then(function (fresh) {
          syncEmptyState(fresh);
          return fresh;
        });
      });
  }

  function applyProgress(targetPct) {
    var fill = el('[data-gift-fill]');
    var track = el('[data-gift-track]');
    if (track) track.setAttribute('aria-valuenow', Math.round(targetPct));
    if (!fill) return;
    fill.style.width = targetPct + '%';
    state.lastPct = targetPct;
  }

  function setMessage(html, isError) {
    var msg = el('[data-gift-message]');
    if (!msg || msg.innerHTML === html) return;
    msg.classList.add('is-swapping');
    setTimeout(function () {
      msg.innerHTML = html;
      msg.classList.toggle('is-error', !!isError);
      msg.classList.remove('is-swapping');
    }, 200);
  }

  function render(cart) {
    var r = root();
    var campaign = readCampaign();
    if (!r || !campaign || !cart) return;

    var subtotal = qualifyingSubtotal(cart, campaign);
    var unlocked = subtotal >= campaign.threshold;
    var hasGift = giftLines(cart).some(function (g) { return !isStaleGift(g, campaign); });
    var pct = Math.min(100, (subtotal / campaign.threshold) * 100);

    applyProgress(pct);
    r.classList.toggle('is-unlocked', unlocked);

    var btn = el('[data-gift-add]');
    var added = el('[data-gift-added]');

    if (unlocked) {
      setMessage(escapeHtml(campaign.unlockMessage));
      if (btn) btn.hidden = hasGift;
      if (added) added.hidden = !hasGift;
      if (!state.confettiFired) {
        state.confettiFired = true;
        fireConfetti(campaign);
      }
    } else {
      setMessage(
        '\uD83C\uDF81 Unlock a FREE ' + escapeHtml(campaign.giftName) + '.<br>' +
        'Spend <strong>' + formatMoney(campaign.threshold - subtotal, campaign) +
        '</strong> more to claim your gift.'
      );
      if (btn) btn.hidden = true;
      if (added) added.hidden = true;
      state.confettiFired = false;
    }

    r.dataset.hydrated = '1';
  }

  function setButtonLoading(loading) {
    var btn = el('[data-gift-add]');
    if (!btn) return;
    btn.disabled = loading;
    btn.classList.toggle('is-loading', loading);
    btn.setAttribute('aria-busy', loading ? 'true' : 'false');
  }

  function restoreFocus() {
    var inner = document.querySelector('cart-drawer .drawer__inner');
    if (inner) inner.focus({ preventScroll: true });
  }

  function refresh() {
    return fetchCart().then(reconcile).then(render);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-gift-add]');
    if (!btn || btn.disabled) return;
    event.preventDefault();
    setButtonLoading(true);
    claim()
      .catch(function () {
        setMessage('Couldn\u2019t add your gift \u2014 please try again.', true);
      })
      .finally(function () { setButtonLoading(false); });
  });

  window.fetch = function () {
    var input = arguments[0];
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isCartCall = CART_PATHS.some(function (p) { return url.indexOf(p) !== -1; });
    var result = originalFetch.apply(null, arguments);
    if (isCartCall) {
      result.then(function () {
        setTimeout(function () { enqueue(refresh); }, 400);
      }).catch(function () {});
    }
    return result;
  };

  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (
      typeof url === 'string' &&
      CART_PATHS.some(function (p) { return url.indexOf(p) !== -1; }) &&
      !this.__bvBound
    ) {
      this.__bvBound = true;
      this.addEventListener('load', function () {
        setTimeout(function () { enqueue(refresh); }, 400);
      });
    }
    return _open.apply(this, arguments);
  };

  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    try {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(function () { enqueue(refresh); }, 400);
      });
    } catch (e) {}
  }

  var mutationTimer = null;
  new MutationObserver(function () {
    var r = root();
    if (!r || r.dataset.hydrated) return;
    clearTimeout(mutationTimer);
    mutationTimer = setTimeout(function () {
      enqueue(refresh);
    }, 80);
  }).observe(document.body, { childList: true, subtree: true });

  function fireConfetti(campaign) {
    if (!campaign.confetti) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var r = root();
    var canvas = el('.bv-gift__confetti');
    if (!r || !canvas) return;

    var ctx = canvas.getContext('2d');
    var dpr = window.devicePixelRatio || 1;
    var w = r.offsetWidth;
    var h = r.offsetHeight;
    if (!w || !h) return;
    canvas.width = w * dpr;
    canvas.height = h * dpr;
    ctx.scale(dpr, dpr);

    var colors = ['#ffffff', '#d9d9d9', '#9a9a9a', '#5c5c5c'];
    var pieces = [];
    for (var i = 0; i < 40; i++) {
      pieces.push({
        x: Math.random() * w,
        y: -10 - Math.random() * 24,
        size: 2.5 + Math.random() * 3,
        vx: (Math.random() - 0.5) * 1.2,
        vy: 1 + Math.random() * 1.6,
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.16,
        color: colors[(Math.random() * colors.length) | 0]
      });
    }

    var start = performance.now();
    (function frame(now) {
      var liveCanvas = el('.bv-gift__confetti');
      if (!liveCanvas || liveCanvas !== canvas) return;
      var t = (now - start) / 2200;
      ctx.clearRect(0, 0, w, h);
      if (t >= 1) return;
      for (var i = 0; i < pieces.length; i++) {
        var p = pieces[i];
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;
        ctx.save();
        ctx.globalAlpha = Math.max(0, 1 - t * 1.15);
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.6);
        ctx.restore();
      }
      requestAnimationFrame(frame);
    })(start);
  }

  function init() { enqueue(refresh); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.__BV_FREE_GIFT_ENGINE__ = {
    refresh: function () { return enqueue(refresh); },
    version: '3.1.0'
  };
})();